import axios from "axios";
import { BASE_URL } from "../constants/APIConstants";
import { authConfig, deleteResource, getResource } from "../api/http";
import {
  decodeEnvelope,
  decryptEnvelope,
  decryptPayload,
  encryptPayload,
} from "../utils/crypto";

export function getAdminList() {
  return getResource("/api/admin", {
    select: (data) => decryptPayload(data.data).savedAdmin,
  });
}

export function getAdminDetails(user_id) {
  return getResource(`/api/admin/details/${user_id}`, {
    select: (data) => decryptPayload(data.data).savedAdmin,
  });
}

/** Resolves with the created admin, or with the API error message. Rejects on network/HTTP errors. */
export async function createAdmin(obj) {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/admin`,
      encryptPayload(obj),
      authConfig()
    );
    const envelope = decodeEnvelope(response.data.data);
    // The API returns `{ error }` instead of an encrypted payload on failure.
    if (envelope.error) {
      return envelope.error;
    }
    return decryptEnvelope(envelope);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/** Resolves with the updated admin; rejects on any error, including API error messages. */
export async function updateAdmin(obj, user_id) {
  try {
    const response = await axios.put(
      `${BASE_URL}/api/admin/${user_id}`,
      encryptPayload(obj),
      authConfig()
    );
    const envelope = decodeEnvelope(response.data.data);
    // The API returns `{ error }` instead of an encrypted payload on failure.
    if (envelope.error) {
      throw new Error(envelope.error);
    }
    return decryptEnvelope(envelope);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export function deleteAdmin(admin_id) {
  return deleteResource(`/api/admin/${admin_id}`);
}

/** Sections, levels and roles of the back-office permissions (with each role's preset). */
export function getPermissionsCatalog() {
  return getResource("/api/admin/permissions/catalog", { rethrow: true });
}

/** Message sent by the API with a refused request (403, 400), if any. */
export function apiMessage(error) {
  return error?.response?.data?.msg || error?.response?.data?.message || "";
}

/**
 * Resets the password of another admin: temporary password emailed, every
 * session of this admin closed. Resolves `{ emailSent, temporaryPassword? }`
 * (the password only when the email could not be sent). Rejects on error.
 */
export function resetAdminPassword(user_id) {
  return axios.post(`${BASE_URL}/api/admin/${user_id}/reset-password`, {}, authConfig()).then((response) => response.data);
}
